import axios from 'axios'

export async function getBillingDataQuery() {
    return axios
        .get(`${process.env.API_URL}/billing`)
        .then(response => response.data)
}

// export async function getBillingData(dispatch, locale) {
//     try {
//         const billingData = await axios
//             .get(`${process.env.API_URL}/billing`)
//             .then(response => response.data)
//         return billingData
//     } catch (ex) {
//         dispatch(
//             enqueueSnackbar({
//                 message: locale.sagasMsgs.commonLoadingError,
//                 options: {
//                     variant: 'error'
//                 }
//             })
//         )
//     }
// }
